// extracted by mini-css-extract-plugin
export default {"appname":"headerStyle_appname__foakG","header":"headerStyle_header__YiiaH","tempselector":"headerStyle_tempselector__ZAbhi","togglebtn":"headerStyle_togglebtn__NX2OZ"};